<template>
  <div class="container">
    <!-- 搜索框 -->
    <div class="search-container">
      <input 
        v-model="searchKeyword" 
        type="text" 
        placeholder="请输入要搜索的物品名称" 
        @input="handleSearch"
        class="search-input"
      />
      <button @click="clearSearch" v-if="searchKeyword" class="clear-btn">清空</button>
    </div>

    <!-- 禁止运输的危险品和违禁品 -->
    <div class="section">
      <h2>禁止运输的危险品和违禁品</h2>
      <table class="table">
        <thead>
          <tr>
            <th>类别</th>
            <th>常见物品</th>
          </tr>
        </thead>
        <tbody>
          <!-- 显示搜索结果 -->
          <tr v-for="(item, index) in filteredItems" :key="index">
            <td>{{ item.dictLabel }}</td>
            <td>{{ item.dictValue }}</td>
          </tr>
        </tbody>
      </table>
      
      <!-- 搜索结果提示 -->
      <div v-if="searchKeyword && filteredItems.length === 0" class="no-results">
        未找到包含“{{ searchKeyword }}”的物品
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { apigetDriction } from "@/api/beecargo/autoCarFeeRules/index.js";
  
export default {
  name: 'ProhibitedItemsTable',
  data() {
    return {
      // 禁止运输的危险品
      dangerousGoods: [
        {
          category: '爆炸品',
          items: '炸药、雷管、导火索、烟花爆竹、摔炮、拉炮、砸炮'
        },
        {
          category: '气体（易燃、毒性、窒息性）',
          items: '氢气、甲烷、乙烷、丙烷、丁烷、乙炔、氯气、氨气、液化石油气、压缩氧气'
        },
        {
          category: '易燃液体',
          items: '汽油、煤油、柴油、苯、甲醇、乙醇（酒精体积 > 75%）、丙酮、乙醚、油漆、稀料、松香油'
        },
        {
          category: '易燃固体、自燃物品、遇湿易燃物品',
          items: '红磷、硫磺、金属钠、钾、镁粉、铝粉、白磷（自燃）、电石（遇水易燃）'
        },
        {
          category: '氧化剂和有机过氧化物',
          items: '高锰酸钾、氯酸钾、过氧化氢（双氧水）、过氧化钠、过氧化钾'
        },
        {
          category: '毒性物质和感染性物质',
          items: '氰化物、砒霜、硒粉、苯酚、汞（水银）、剧毒农药、病毒、细菌、生物制品'
        },
        {
          category: '放射性物质',
          items: '铀、钚、镭、钴-60、放射性同位素'
        },
        {
          category: '腐蚀性物质',
          items: '硫酸、盐酸、硝酸、氢氧化钠、氢氧化钾、蓄电池（含酸液）'
        }
      ],
      
      // 禁止运输的违禁品
      prohibitedItems: [
        {
          category: '枪支弹药',
          items: '军用枪、民用枪、仿真枪、主要零部件、子弹、炮弹、手榴弹、地雷'
        },
        {
          category: '管制器具',
          items: '匕首、三棱刀、弹簧刀（跳刀）、弩、电击器、催泪瓦斯'
        },
        {
          category: '毒品及成瘾性物质',
          items: '鸦片、吗啡、海洛因、可卡因、大麻、冰毒、摇头丸、K粉'
        },
        {
          category: '易制毒化学品',
          items: '麻黄素、伪麻黄素、醋酸酐、甲苯、丙酮、高锰酸钾'
        },
        {
          category: '非法出版物',
          items: '淫秽色情、暴力恐怖、邪教、煽动民族仇恨的书籍、音像制品'
        },
        {
          category: '货币及有价证券',
          items: '伪造的货币、有价证券、空白发票'
        },
        {
          category: '珍贵动植物及其制品',
          items: '大熊猫、金丝猴等保护动物及其皮毛、象牙、犀牛角、红豆杉'
        },
        {
          category: '其他违禁品',
          items: '伪造的证件、印章、军用标志、盗窃物、赃物'
        }
      ],
      
      // 搜索关键词
      searchKeyword: '',
      
      // 过滤后的数据
      filteredItems: []
    }
  },
  watch: {
    // 监听搜索关键词变化
    searchKeyword: {
      handler(newVal) {
        this.handleSearch();
      },
      immediate: true
    }
  },
  created(){
    this.getList();
  },
  methods: {
    getList(){
      this.$toast({
        type:"loading",
        forbidClick:true,
        duration:0,
        message:"加载中"
      });
      apigetDriction().then(res=>{
        this.allItems = res.data;
        this.filteredItems = JSON.parse(JSON.stringify(this.allItems));
      }).finally(()=>Toast.clear())
    },
    // 处理搜索
    handleSearch() {
      const keyword = this.searchKeyword.trim();
      
      if (!keyword) {
        // 如果搜索关键词为空，显示全部数据
        this.filteredItems = this.allItems;
        return;
      }
      
      // 使用正则表达式进行模糊匹配
      const regex = new RegExp(keyword, 'i'); // 'i' 表示不区分大小写
      
      // 过滤出包含搜索关键词的物品
      this.filteredItems = this.allItems.filter(item => {
        // 检查类别是否包含关键词
        if (regex.test(item.dictLabel)) {
          return true;
        }
        
        // 检查物品列表是否包含关键词
        // 将物品字符串按顿号分割，然后检查每个物品
        const itemsArray = item.dictValue.split('、');
        return itemsArray.some(itemName => regex.test(itemName));
      });
    },
    
    // 清空搜索
    clearSearch() {
      this.searchKeyword = '';
      this.filteredItems = this.allItems;
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
  font-family: Arial, sans-serif;
}

.search-container {
  display: flex;
  margin-bottom: 20px;
  padding: 0 10px;
  gap: 10px;
  align-items: center;
}

.search-input {
  flex: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.clear-btn {
  padding: 8px 16px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.clear-btn:hover {
  background-color: #d32f2f;
}

.section {
  margin-bottom: 40px;
}

h2 {
  color: #333;
  margin-bottom: 15px;
  border-bottom: 2px solid #eee;
  padding-bottom: 8px;
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
}

.table th,
.table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.table th {
  background-color: #f2f2f2;
  font-weight: bold;
  color: #333;
}

.table tbody tr:hover {
  background-color: #f9f9f9;
}

.table td {
  word-break: break-word;
}

.no-results {
  color: #999;
  text-align: center;
  padding: 20px;
  font-style: italic;
}

@media (max-width: 768px) {
  .container {
    padding: 10px;
  }
  
  .table {
    font-size: 14px;
  }
  
  .table th,
  .table td {
    padding: 8px 10px;
  }
  
  .search-container {
    flex-direction: column;
  }
  
  .search-input {
    width: 100%;
  }
  
  .clear-btn {
    width: 100%;
  }
}
</style>